
import Loading from 'vue-loading-overlay'
import { Options, Vue } from 'vue-class-component'
import { Manager } from '@/mechanics/tableMechanic'
import {
  ObjectTemplate,
  MechanicAbstract,
  ObjectType,
  StatTypeEnum,
  ObjectTypeEnum,
  RegionType,
  RegionEnum
} from '@cybertale/interface'
import router from '@/router'
import { TYPE, useToast } from 'vue-toastification'
import ToastComponent from '@/components/ToastComponent.vue'
import { Definitions } from '@geocms/components'
import { $t } from '@geocms/localization'
@Options({
  computed: {
    $t () {
      return $t
    }
  },
  components: {
    Loading
  }
})
export default class TableComponent extends Vue {
  headers: string[] = []
  regionEnum = RegionEnum
  statTypeEnum = StatTypeEnum
  objectTypeEnum = ObjectTypeEnum
  objectType = ObjectType
  mechanic: MechanicAbstract = new Manager.Mechanic.TableMechanic(this.reRender.bind(this))
  renderComponent= true
  loadingComponents = true
  objectTemplates!: ObjectTemplate[]
  entities: ObjectTemplate[][] = []
  currentPage = 1
  isInitRunning = false
  orderBy = 'asc'
  isLoading = false
  groupTypeFilter: { [key: string]: string } = { all: '', group: 'group', template: 'template' }
  filters = { code: '', group: '', division: '' }
  onScroll: ((this: Window, ev: Event) => any) | null = null

  beforeUnmount () {
    this.mechanic.UnsubscribeConditions()
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll)
    }
  }

  created () {
    this.Init()
  }

  mounted () {
    if (router.currentRoute.value.name === Definitions.Entity.Def) {
      this.onScroll = async () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        // Check if isLoading is false and user is at the bottom of the page
        if (!this.isLoading && !this.isInitRunning && !this.renderComponent && scrollHeight - window.innerHeight - scrollTop <= 5) {
          // Set isLoading to true
          this.isLoading = true

          // Fetch new data
          await this.scroll() // TODO scroll is disabling resorting on group

          // Set isLoading back to false
          this.isLoading = false
        }
      }

      // Subscribe to the scroll event
      window.addEventListener('scroll', this.onScroll)
    }
  }

  reRender (reverseOrder: boolean) {
    if (reverseOrder) {
      this.reverseEntities()
    } else {
      if (this.loadingComponents) {
        this.entities = []
        this.objectTemplates = []
        this.headers = []
        this.Init()
      } else {
        this.loadingComponents = true
      }
    }
  }

  changeRender () {
    if (this.renderComponent) {
      this.entities = []
      this.objectTemplates = []
      this.headers = []
      this.mechanic = new Manager.Mechanic.TableMechanic(this.reRender.bind(this))
      this.Init()
    } else {
      this.renderComponent = true
    }
  }

  async scroll () {
    if (this.isInitRunning) { return }
    await this.Init()
  }

  handleFilterChange (): void {
    if (!this.isInitRunning) {
      this.renderComponent = true
      this.changeRender()
      this.Init()
    }
  }

  checkRoute () {
    return router.currentRoute.value.name === Definitions.Entity.Def
  }

  async Init () {
    if (this.isInitRunning) { return }
    this.isInitRunning = true
    switch (router.currentRoute.value.name) {
      case Definitions.Entity.Def:
        // console.log(this.orderBy)
        this.objectTemplates = this.mechanic.InitSet(await this.mechanic.InitGet('-1', JSON.stringify({ api: 'entity', filters: this.filters, order: this.orderBy })))
        break
      case Definitions.Group.Def:
        this.objectTemplates = this.mechanic.InitSet(await this.mechanic.InitGet('-1', JSON.stringify({ api: 'group', filters: this.filters, order: this.orderBy })))
        break
      case Definitions.Division.Def:
        this.objectTemplates = this.mechanic.InitSet(await this.mechanic.InitGet('-1', 'division'))
        break
      case Definitions.Group.Edit:
        this.objectTemplates = this.mechanic.InitSet(await this.mechanic.InitGet('-1', 'filter/attribute/' + router.currentRoute.value.params.id))
        break
      case Definitions.Group.Add:
        this.renderComponent = false
        return
      case Definitions.Administration.AccountProfile:
        this.objectTemplates = this.mechanic.InitSet(await this.mechanic.InitGet('-1', 'permissions/user'))
        break
      case Definitions.Administration.Def:
        this.objectTemplates = this.mechanic.InitSet(await this.mechanic.InitGet('-1', 'users'))
        break
    }
    if (Object.keys(this.objectTemplates).length === 0) {
      this.renderComponent = false
      return
    }
    let tempId = null
    let tempObjectTemplates = []
    for (const element of this.objectTemplates) {
      // console.log(element.Stats[StatTypeEnum.Tag].Data)
      if (element.Stats[StatTypeEnum.Id].Data === tempId) {
        tempObjectTemplates.push(JSON.parse(JSON.stringify(element)))
      } else {
        if ((this.entities === undefined || this.entities.length < 1) && tempObjectTemplates.length > 0) {
          this.entities = [tempObjectTemplates]
        } else if (this.entities !== undefined && tempObjectTemplates.length > 0) {
          this.entities.push(JSON.parse(JSON.stringify(tempObjectTemplates)))
        }
        tempObjectTemplates = []
        tempObjectTemplates.push(JSON.parse(JSON.stringify(element)))
      }
      tempId = element.Stats[StatTypeEnum.Id].Data
    }
    if (this.entities === undefined || this.entities.length < 1) {
      this.entities = [tempObjectTemplates]
    } else {
      this.entities[this.entities.length] = tempObjectTemplates
    }
    this.getHeaders()
    this.renderComponent = false
    this.loadingComponents = false
    this.isInitRunning = false
  }

  reverseEntities () {
    if (!this.isInitRunning) {
      const groupValues = Object.values(this.groupTypeFilter)
      this.renderComponent = true
      const currentGroupIndex = groupValues.indexOf(this.filters.group) + 1
      if (currentGroupIndex >= groupValues.length && this.filters.group !== '') { // TODO something is not working (ORDER), most likely fixed
        this.filters.group = groupValues[0]
      } else {
        this.filters.group = groupValues[currentGroupIndex]
      }
      useToast()({
        component: ToastComponent,
        props: { msg: { title: 'Loading...', info: this.filters.group === '' ? 'Loading all.' : 'Loading ' + this.filters.group + ' only.' } }
      }, {
        type: TYPE.INFO
      })
      this.changeRender()
    }
  }

  getHeaders () : void { // TODO Needs to be reworked. @JosoMarich
    this.headers = []
    for (const header of this.objectTemplates) {
      if (this.headers.indexOf(header.Stats[StatTypeEnum.Label].Data) === -1 && header.Stats[StatTypeEnum.BelongsTo] === undefined) {
        this.headers[this.headers.length] = header.Stats[StatTypeEnum.Label].Data
      }
    }
  }

  getComponent (_regionEnum : number, _objectEnum: number) {
    return RegionType.RegionTypes[_regionEnum].ObjectTypes[_objectEnum].GetComponent()
  }
}
